import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/authSlice';
import employeeSlice from './slices/employeeSlice';
import attendanceSlice from './slices/attendanceSlice';
import locationSlice from './slices/locationSlice';
import leaveSlice from './slices/leaveSlice';
import superAdminSlice from './slices/superAdminSlice';
import bgvSlice from './slices/bgvSlice';
import payrollSlice from './slices/payrollSlice';
import geoLocationSlice from './slices/geoLocationSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    employees: employeeSlice,
    attendance: attendanceSlice,
    locations: locationSlice,
    leave: leaveSlice,
    superAdmin: superAdminSlice,
    bgv: bgvSlice,
    payroll: payrollSlice,
    geoLocation: geoLocationSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
